import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class X40Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false
        };
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;
        
        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.configuration.transom.Name} port={this.props.configuration.transom.Port} transomSize={{ width: 2895, height: 780 }} transform={
                [
                    0.054992, -0.003693, 0, -0.000034,
                    0.023795, 0.134642, 0, 0.000081,
                    0, 0, 1, 0,
                    243, 366, 0, 1
                ]}>
                <ConfiguratorImage boat="X4_0" configuration={this.props.configuration.exterior} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>

                    <h1><Trans defaults='Summary' /></h1>
                    <h2><Trans defaults='Congratulations!' /></h2>
                    <p><Trans defaults='You have now configured the basics of an X4<sup>0</sup>. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>

                    <PdfForm boat="x40" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />

                    <ShareFrom configuration={this.props.configuration} boat="x40" code={this.props.code} />

                    <Disclaimer />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X40Summary);


// WEBPACK FOOTER //
// ./src/X40/X40Summary.js